import AuthMethodSwitch from '@components/AuthMethods/AuthMethodSwitch';
import { ActionsFooter, ApprovalDialogButton } from '@components/Forms';
import { LoadingButton } from '@mui/lab';
import { Box, Grid, Link as MUILink, Typography } from '@mui/material';
import { onSubmitForm } from '@utils/forms';
import { APP_ROUTES } from 'constants/routes';
import { useFormik } from 'formik';
import { useToast } from 'hooks';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { ISSOSettings } from 'types/settings';

interface IProjectSSOProps {
	settings?: ISSOSettings;
	onSave: (data: ISSOSettings) => Promise<ISSOSettings>;
}

const DEFAULT_FORM: ISSOSettings = {
	id: '',
	version: 0,
	enabled: false
};

const ProjectSSOPage: FC<IProjectSSOProps> = ({ onSave, settings }) => {
	const { addToast } = useToast();

	const formik = useFormik<ISSOSettings>({
		enableReinitialize: true,
		initialValues: {
			...DEFAULT_FORM,
			...settings
		},
		onSubmit: onSubmitForm<ISSOSettings>(onSave, addToast)
	});

	return (
		<Box display="flex" flexDirection="column" flexGrow={1} overflow="hidden">
			<Box display="flex" flexDirection="column" flexGrow={1} component="form">
				<Grid item pl={4}>
					<AuthMethodSwitch formik={formik} />
				</Grid>
				<Grid
					container
					flexGrow={1}
					flexDirection="row"
					alignContent="flex-start"
				>
					<Box display="flex" flexDirection="row" p={4}>
						<Typography
							variant="body1"
							display="flex"
							sx={{
								marginRight: '0.2rem'
							}}
						>
							{intl.tr('pages.authMethods.sso.body1')}
						</Typography>
						<Link to={APP_ROUTES.tenants}>
							<MUILink component="span">
								{intl.tr('pages.authMethods.sso.body.link')}
							</MUILink>
						</Link>
					</Box>
				</Grid>
				<ActionsFooter>
					<LoadingButton
						color="primary"
						variant="contained"
						onClick={() => formik.handleSubmit()}
						loading={formik.isSubmitting}
						disabled={!formik.dirty}
						sx={{ marginRight: 1 }}
					>
						{intl.tr('button.save')}
					</LoadingButton>
					<ApprovalDialogButton
						buttonText={intl.tr('button.cancel')}
						onApprove={formik.resetForm}
						disabled={!formik.dirty}
						title={intl.tr('discard.changes.dialog.title')}
						question={intl.tr('discard.changes.dialog.question')}
						approveText={intl.tr('discard.changes.dialog.approve')}
					/>
				</ActionsFooter>
			</Box>
		</Box>
	);
};

ProjectSSOPage.defaultProps = {
	settings: DEFAULT_FORM
};

export default ProjectSSOPage;
